export const UserMenus = [
  {
    label: "Dashboard",
    key: "dashboard",
    icon: "ki-outline ki-element-11",
  },
  {
    label: "Dashboard V2",
    key: "dashboard-v2",
    icon: "ki-outline ki-element-11",
  },
  {
    label: "Alerts",
    key: "alerts",
    icon: "ki-outline ki-notification-on",
  },
  {
    label: "Configurations",
    key: "settings",
    icon: "ki-outline ki-gear",
    // UI hint: open subsections by default and allow them to be closable via configuration
    defaultOpen: true,
    closable: true,
    children: [
      {
        key: "settings/products",
        label: "Products",
        icon: "ki-outline ki-directbox-default",
        // mark as subsection so renderer can apply indentation / different styling
        isSubSection: true,
        className: "sidebar-submenu-item",
        iconClassName: "sidebar-submenu-icon",
      },
      {
        key: "settings/expenses",
        label: "Expenses",
        icon: "ki-outline ki-finance-calculator",
        isSubSection: true,
        className: "sidebar-submenu-item",
        iconClassName: "sidebar-submenu-icon",
      },
      {
        key: "settings/myprofile",
        label: "My Profile",
        icon: "ki-outline ki-user",
        isSubSection: true,
        className: "sidebar-submenu-item",
        iconClassName: "sidebar-submenu-icon",
      },
      {
        key: "settings/marketplace-credentials",
        label: "Marketplace Credentials",
        icon: "ki-outline ki-lock",
        isSubSection: true,
        className: "sidebar-submenu-item",
        iconClassName: "sidebar-submenu-icon",
      },
      {
        key: "settings/billing",
        label: "Billing",
        icon: "ki-outline ki-wallet",
        isSubSection: true,
        className: "sidebar-submenu-item",
        iconClassName: "sidebar-submenu-icon",
      },
      {
        key: "settings/file-manager",
        label: "Import & Export",
        icon: "ki-outline ki-cloud-add",
        isSubSection: true,
        className: "sidebar-submenu-item",
        iconClassName: "sidebar-submenu-icon",
      },
      {
        key: "settings/advance-settings",
        label: "Advanced Settings",
        icon: "ki-outline ki-gear",
        isSubSection: true,
        className: "sidebar-submenu-item",
        iconClassName: "sidebar-submenu-icon",
      },
      // {
      //   key: "settings/manage-seller",
      //   label: "Manage Seller Accounts",
      //   icon: "ki-outline ki-people",
      //   isSubSection: true,
      //   className: "sidebar-submenu-item",
      //   iconClassName: "sidebar-submenu-icon",
      // },
    ],
  },
];
